import {
  getUid,
} from './getUid';

import {
  getDatabase,
  onChildAdded,
  ref,
  set,
} from 'firebase/database';

import {
  app,
} from './initializeApp';

import { pipe } from 'lodash/fp';

export async function initFatsecretApi()
{
  const handleExistingUser = uid =>
  (
    set
    (
      ref(getDatabase(app), `fatsecret/${ uid }/message`),
      'Hello, world!'
    )
  );

  const uid = await getUid();

  await handleExistingUser(uid);

  await new Promise(resolve => {
    const unsubscribe = onChildAdded
    (
      ref(getDatabase(app), `fatsecretProfiles/${ uid }`),
      pipe
      ([
        () => unsubscribe(),
        () => resolve(),
      ]),
    )
  });
}